export default {
    not_evaluated: 'not evaluated',
    incompletely_evaluated: 'incompletely evaluated',
    fully_evaluated: 'completely evaluated',
    total: 'Participations in total'
}
